import useTranslation from "../../common/translations";
import { DEFAULT_SORT, SORT_OPTIONS, SORT_PARAM } from "../constants";
import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import clsx from "clsx";
import React from "react";
export default function SortSection({ isOpen, onToggle, }) {
    var _a;
    const { t } = useTranslation("offer-filters");
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const currentSort = String((_a = selectedState[SORT_PARAM]) !== null && _a !== void 0 ? _a : DEFAULT_SORT);
    function handleChange(value) {
        dispatch({
            type: "set_sort",
            payload: value === DEFAULT_SORT ? undefined : value,
        });
    }
    return (<div>
      <button type="button" onClick={onToggle} className="w-full flex items-center justify-between py-[17px] text-left">
        <span>{t("sort.label")}</span>
        <svg className={clsx("size-6", isOpen ? "rotate-180" : "")} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M2.00134 17H3.41534L12.0013 8.414L20.5873 17H22.0013V15.586L12.4158 6H11.5883L2.00134 15.586V17Z" fill="currentColor"/>
        </svg>
      </button>
      {isOpen && (<div className="pb-4 flex flex-col">
          {SORT_OPTIONS.map((option) => (<label key={option.value} className="flex items-center gap-3 py-2 cursor-pointer">
              <input type="radio" name="sort" value={option.value} checked={currentSort === option.value} onChange={() => handleChange(option.value)} className="rounded-full border-[#0C191D] size-[18px] text-black focus:ring-0 focus:ring-offset-0 cursor-pointer"/>
              <span className="text-gray-900">{t(option.labelKey)}</span>
            </label>))}
        </div>)}
    </div>);
}
